import { cn } from "cn";
import type { ComponentProps, FC } from "react";
import React from "react";

import { Button } from "@react/ui-primitives/button";

import type { IconComponent } from "../../icon/index.ts";

interface AppToolButtonProps
  extends Omit<ComponentProps<typeof Button>, "children"> {
  readonly icon: IconComponent;
}

export const AppToolButton: FC<AppToolButtonProps> = ({
  className,
  icon: IconComponent,
  ...props
}) => (
  <Button
    className={cn(
      `
        bg-header-accent text-header-foreground
        hover:bg-header-accent/80 hover:text-header-foreground
      `,
      className,
    )}
    round
    size="icon-sm"
    type="button"
    {...props}
  >
    <IconComponent />
  </Button>
);
